import { useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import GrupoService from "../../../services/resource/grupoService";
import UsuarioService from "../../../services/resource/usuarioService";

const grupoService = new GrupoService();
const usuarioService = new UsuarioService();

// Torna o "Responsável" do cabeçalho da solicitação clicável: ao clicar, busca sob demanda (e só
// uma vez) os membros do grupo ou os dados do usuário responsável e mostra num painel flutuante.
export default function ResponsavelPopover({ solicitacao }) {
    const overlayRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState(null);
    const [erro, setErro] = useState(false);

    const grupoId = solicitacao.grupoResponsavelAtualId;
    const usuarioId = solicitacao.responsavelAtualId;
    const nome = solicitacao.responsavelAtualNome || solicitacao.grupoResponsavelAtualNome;

    if (!nome) {
        return <span className="block text-foreground font-medium truncate" title="-">-</span>;
    }

    function abrir(e) {
        overlayRef.current?.toggle(e);
        if (dados || loading) return;

        setLoading(true);
        setErro(false);
        const requisicao = grupoId
            ? grupoService.buscarGrupo(grupoId).then(res => ({ tipo: "grupo", ...res.data }))
            : usuarioService.buscarUsuario(usuarioId).then(res => ({ tipo: "usuario", ...res.data }));

        requisicao
            .then(setDados)
            .catch(() => setErro(true))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <button
                type="button"
                onClick={abrir}
                className="block text-foreground font-medium truncate text-left hover:text-primary hover:underline transition-colors duration-150"
                title={nome}
            >
             {!solicitacao.responsavelAtualNome ? `Grupo (${nome})` : nome  }
            </button>

            <OverlayPanel ref={overlayRef} className="max-w-xs">
                <div className="min-w-[220px] p-1">
                    {loading && <p className="text-xs text-muted-foreground">Carregando...</p>}
                    {!loading && erro && <p className="text-xs text-destructive">Erro ao carregar informações.</p>}

                    {!loading && !erro && dados?.tipo === "grupo" && (
                        <div className="flex flex-col gap-2 p-2">
                            <span className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">
                                Grupo {dados.nome}
                            </span>
                            {(dados.usuarios || []).length === 0 ? (
                                <p className="text-xs text-muted-foreground">Nenhum usuário neste grupo.</p>
                            ) : (
                                <ul className="flex flex-col gap-2 max-h-60 overflow-y-auto">
                                    {dados.usuarios.map(u => (
                                        <li key={u.id}>
                                            <div className="text-sm font-medium text-foreground">{u.nome}</div>
                                            <div className="text-xs text-muted-foreground">{u.email}</div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}

                    {!loading && !erro && dados?.tipo === "usuario" && (
                        <div className="flex flex-col gap-1">
                            <span className="text-sm font-medium text-foreground">{dados.nome}</span>
                            <span className="text-xs text-muted-foreground">{dados.email}</span>
                            {dados.filialNome && <span className="text-xs text-muted-foreground">Filial: {dados.filialNome}</span>}
                            {!dados.ativo && (
                                <span className="mt-1 inline-flex w-fit rounded-full bg-muted px-2 py-0.5 text-[10px] font-semibold text-muted-foreground">
                                    Inativo
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </OverlayPanel>
        </>
    );
}
